<template>
  <Drawer
    width="850"
    :title="customerName"
    v-model="drawerOpened"
  >
    <div class="drawer-content">
      <div class="info-item">
        <h3>客户</h3>
        <div>{{ customerName ? customerName : "" }}</div>
      </div>
      <div class="info-item">
        <h3>应收总额</h3>
        <div>
          {{
            openedAR.totalAccountsReceivable
              ? openedAR.totalAccountsReceivable.toLocaleString()
              : ""
          }}
        </div>
      </div>
      <div class="info-item">
        <h3>逾期总额</h3>
        <div>
          {{
            openedAR.totalPastDueAR
              ? openedAR.totalPastDueAR.toLocaleString()
              : ""
          }}
        </div>
      </div>
      <div class="table">
        <div
          class="table-wrapper-ar"
          ref="tableWrapper"
        >
          <Table
            :columns="columns"
            :data="openedAR.arTable ? openedAR.arTable : []"
            :loading="tableLoading"
            border
          ></Table>
        </div>
        <div
          class="table-wrapper-receive"
          ref="tableWrapper"
        >
          <Table
            :columns="receiveColumns"
            :data="receiveList"
            :loading="tableLoading"
            border
          >
            <template slot-scope="{ row, column, index }" slot="amount">
              <div v-if="row.amount">{{ Number(row.amount).toLocaleString("zh", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }) }}
                </div>
                <div v-else>{{ row.submitAmount }}<Icon type="md-help" style="position: relative; top: -2px"/></div>
            </template>
          </Table>
        </div>
      </div>
    </div>
  </Drawer>
</template>

<script>
import { mapActions, mapState } from "vuex";
import dayjs from "dayjs";
const typeToText = {
  trans: "银行转账",
  bankAccBill: "银承",
  commAccBill: "商承",
  check: "支票",
  cash: "现金钞票",
  yun: "云信通",
  jian: "建信融通",
  bankAccBillPaper: "纸质银承",
};

export default {
  name: "ARDetailDrawer",
  data() {
    return {
      drawerOpened: false,
      tableLoading: false,
      openedAR: {
        totalAccountsReceivable: null,
        totalPastDueAR: null,
      },
      customerName: null,
      columns: [
        {
          title: "月份",
          key: "month",
          align: "left",
          minWidth: 30,
          render: (h, params) => {
            return h("div", params.row.year + "/" + params.row.month);
          },
        },
        {
          title: "账龄",
          key: "estAging",
          align: "right",
          minWidth: 30,
          render: (h, params) => {
            return h(
              "div",
              this.calcEstAging(params.row.year, params.row.month)
            );
          },
        },
        {
          title: "金额",
          key: "estAging",
          align: "right",
          minWidth: 120,
          render: (h, params) => {
            return h(
              "div",
              params.row.accountsReceivable &&
                (params.row.accountsReceivable > 1 ||
                  params.row.accountsReceivable < -1)
                ? Number(params.row.accountsReceivable).toLocaleString("zh", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })
                : ""
            );
          },
        },
      ],
      receiveColumns: [
        {
          title: "到账日期",
          key: "receivedAt",
          align: "left",
          minWidth: 50,
          render: (h, params) => {
            return h(
              "div",
              dayjs(params.row.receivedAt).format("YYYY/M/D")
            );
          },
        },
        {
          title: "金额",
          key: "estAging",
          align: "right",
          minWidth: 120,
          slot: 'amount',
        },
        {
          title: "类型",
          key: "type",
          align: "center",
          minWidth: 100,
          render: (h, params) => {
            return h(
              "div",
              typeToText[params.row.type]
            );
          },
        },
      ],
      receiveList: [],
      yearMonth: null,
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.auth.currentUser,
    }),
  },
  methods: {
    ...mapActions({
      createEntity: "entity/createEntityAction",
      updateEntity: "entity/updateEntityAction",
      getReceive: "receive/getReceiveAction",
    }),
    async openDrawer(ar, yearMonth) {
      if (ar) {
        this.openedAR.totalAccountsReceivable = ar.totalAccountsReceivable;
        this.openedAR.totalPastDueAR = ar.totalPastDueAR;
        this.openedAR.arTable = ar?.arTable;
        this.openedAR._id = ar._id;
        this.customerName = ar.customer.abbr ?? ar.customer.name;
        this.yearMonth = yearMonth;
        const data = await this.getReceive({ from: ar.customer._id });
        this.receiveList = data.receiveList;
      }
      this.drawerOpened = true;
    },
    handleSubmit(name) {
      this.$refs[name].validate(async (valid) => {
        if (valid) {
          try {
            if (this.openedAR) {
              await this.updateEntity({
                id: this.openedAR._id,
                data: this.formItem,
              });
            } else {
              await this.createEntity(this.formItem);
            }
            this.$Message.success("保存成功!");
            this.drawerOpened = false;
          } catch (error) {
            this.$Message.error(`失败: ${error}`);
          }
        } else {
          this.$Message.error("保存失败!");
        }
      });
    },
    calcEstAging(year, month) {
      const date = dayjs(year + "/" + month);
      const yearMonth = dayjs(this.yearMonth);
      const calcDate = yearMonth.diff(date, "month");
      return calcDate + 1;
    },
  },
};
</script>
<style lang="stylus" scoped>
.table
  display flex

.table-wrapper-ar
  width 100%
  height calc(100% - 48px)
  margin-right 8px

.table-wrapper-receive
  width 100%
  height calc(100% - 48px)
</style>